<p-breadcrumb [model]="items" [home]="home" styleClass="bg-transparent border-0 p-0">
</p-breadcrumb>
